import { ScoreType } from '../../../../store/admin/eventFormats/store';
import { IHoleScore } from '../../../../store/player/scores/store';

import { holesList } from '../../../../Utils/holesList';
import { TPartials } from '../../Hooks/useGetProcessedValues/useGetProcessedValues.hook';
import { IStateDispatchActions } from '../RoundScoreSummary.context';

interface ISetClubIdAugmentedArgs {
  end?: number;
  partials?: TPartials;
  penalties: number | undefined;
  scores: IHoleScore[];
  scoreType: ScoreType | undefined;
  start?: number;
}

export type IProcessScores = (args: ISetClubIdAugmentedArgs) => void;

export const processScores: IStateDispatchActions<IProcessScores> = (_, dispatch) => args => {
  const { penalties, scores, scoreType } = args;

  const currentScores = scores ? scores.sort((a, b) => a.order - b.order) : [];

  // tslint:disable-next-line: no-shadowed-variable
  holesList.forEach((_, i) => {
    if (!currentScores[i] || currentScores[i].order !== i) {
      currentScores.splice(i, 0, {
        grossStableford: '--',
        handicap: '--',
        holeHandicap: '--',
        holePar: '--',
        net: '--',
        netStableford: '--',
        order: i,
        original: '--'
      } as any);
    }
  });

  const appliedHandicaps = currentScores.map(s => String(s.handicap));
  const handicaps = currentScores.map(s => String(s.holeHandicap));
  const pars = currentScores.map(s => String(s.holePar));
  const gross = currentScores.map(s => String(s.gross || s.original));
  const nets = currentScores.map(s => String(s.net));
  const originals = currentScores.map(s => String(s.original));
  const stablefords = currentScores.map(s =>
    String(scoreType === ScoreType.GROSS ? s.grossStableford : s.netStableford)
  );

  const totalGross =
    gross.reduce((sum, g) => sum + (Number(g) || 0), 0) + Number(penalties ? penalties : 0);
  const totalNet =
    nets.reduce((sum, n) => sum + (Number(n) || 0), 0) + Number(penalties ? penalties : 0);

  dispatch({
    type: 'setStringArrayValue',
    value: { field: 'appliedHandicaps', value: appliedHandicaps }
  });
  dispatch({ type: 'setStringArrayValue', value: { field: 'handicaps', value: handicaps } });
  dispatch({ type: 'setStringArrayValue', value: { field: 'pars', value: pars } });
  dispatch({ type: 'setStringArrayValue', value: { field: 'gross', value: gross } });
  dispatch({ type: 'setStringArrayValue', value: { field: 'nets', value: nets } });
  dispatch({ type: 'setStringArrayValue', value: { field: 'originals', value: originals } });
  dispatch({ type: 'setStringArrayValue', value: { field: 'stablefords', value: stablefords } });

  dispatch({ type: 'setTotals', value: { gross: totalGross, net: totalNet } });
};
